/**
 * input component for input macro in form.twig
 *
 * name: name of the field
 * value: value of the field
 * liveChangeEvent: the live change event describes, if a change event should be dispatched with every letter
 *                  false: change event is only dispatched, when focus is gone from the field
 *                  true: change event is dispatched for every letter (e.g. accountant directory filter)
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('bxUserAuthentication', (config) => ({
        afterAllowAccessData: config.afterAllowAccessData ?? '{}',
        verifyUser() {
            let afterAllowAccessData = JSON.parse(this.afterAllowAccessData);
            if (afterAllowAccessData.type === 'eventregistration') {
                afterAllowAccessData.data['apiProvider'] = this.$store.eventRegistrationStore.apiProvider;
            }

            window.postRequest({
                params: {
                    action: 'actions/bx-api-client-module/bx-user-authentication/verify-user',
                },
                data: afterAllowAccessData,
            }).then((result) => {
                window.location = result.data.authenticationEndpoint;
            });
        },
    }));
});
